import EventEmitter from 'events'
import * as THREE from "three";

import Config from './Config'

import ImagePlane from './ImagePlane'
import lerp from '../modules/lerp'

import vertexShader from './shader/vertex.vert'
import fragmentShader from './shader/frag.frag'

export default class AppCanvas extends EventEmitter {
  constructor() {
    super()
		
		this.container = document.getElementById('CanvasContainer')

    this.setConfig()
		
		this.renderer = new THREE.WebGLRenderer({
			canvas: this.container.querySelector('canvas'),
			alpha: true,
		});

		this.renderer.setPixelRatio(Config.dpr)
    this.renderer.setSize(Config.width, Config.height)

		// ウィンドウとwebGLの座標を一致させるため、描画がウィンドウぴったりになるようカメラを調整
		this.fov = 60; // 視野角
		this.fovRad = (this.fov / 2) * (Math.PI / 180);
		this.dist = Config.height / 2 / Math.tan(this.fovRad);

		this.camera = new THREE.PerspectiveCamera(
			this.fov,
			Config.width / Config.height,
			0.1,
			2000
		);
		this.camera.position.z = this.dist;

		this.scene = new THREE.Scene();
		const loader = new THREE.TextureLoader();

		// 画像をテクスチャにしたplaneを扱うクラス
		// Planeメッシュを作る関数

		// スクロール追従
		this.targetScrollY = 0; // スクロール位置
		this.currentScrollY = 0; // 線形補間を適用した現在のスクロール位置
		this.scrollOffset = 0; // 上記2つの差分

		this.imagePlaneArray = [];
		// 毎フレーム呼び出す


		// リサイズ処理
		let timeoutId = 0;


  }
  init() {
    const imageArray = [...document.querySelectorAll('.js-webglImage')];
    for (const img of imageArray) {
      img.classList.add('is-invisible')
      const mesh = this.createMesh(img);
      this.scene.add(mesh);

      const imagePlane = new ImagePlane(mesh, img);
      imagePlane.setParams();

      this.imagePlaneArray.push(imagePlane);
    }
  }
  updateScroll() {
    // スクロール位置を取得
    this.targetScrollY = document.documentElement.scrollTop;
    // リープ関数でスクロール位置をなめらかに追従
    this.currentScrollY = lerp(this.currentScrollY, this.targetScrollY, 0.1);
    
    this.scrollOffset = this.targetScrollY - this.currentScrollY;
  };

  createMesh(img) {
    const loader = new THREE.TextureLoader();

    const texture = loader.load(img.src);
    
    const uniforms = {
      uTexture: { value: texture },
      uImageAspect: { value: img.naturalWidth / img.naturalHeight },
      uPlaneAspect: { value: img.clientWidth / img.clientHeight },
      uTime: { value: 0 },
    };
    
    const geo = new THREE.PlaneGeometry(1, 1, 100, 100); // 後から画像のサイズにscaleするので1にしておく
    const mat = new THREE.ShaderMaterial({
      uniforms,
      vertexShader: vertexShader,
      fragmentShader: fragmentShader,
    });
    const mesh = new THREE.Mesh(geo, mat);
    return mesh;
  };

  setConfig() {
    // canvasの親要素からサイズを取得
    const width = window.innerWidth
    const height = window.innerHeight
    Config.dpr = Math.min(window.devicePixelRatio, 2)
    Config.width = width,
    Config.height = height,
    Config.halfWidth = Config.width / 2
    Config.halfHeight = Config.height / 2
    Config.aspectRatio = Config.width / Config.height

  }

  update() {
    // console.log('update')
    this.updateScroll();
    for (const plane of this.imagePlaneArray) {
      plane.update(this.scrollOffset);
    }
    this.renderer.render(this.scene, this.camera);
  }

  resize() {
    this.setConfig()
    this.renderer.setSize(Config.width, Config.height);
    
    this.camera.aspect = Config.width / Config.height;
    this.camera.updateProjectionMatrix();

    this.dist = Config.height / 2 / Math.tan(this.fovRad);
    this.camera.position.z = this.dist;

  };
}
